export default {"src":"/_next/static/media/empty-state-star.78a0bbde.svg","height":64,"width":65,"blurWidth":0,"blurHeight":0};